import {SqlParam} from '../../sql/message/SqlParam';

export class ReadSql {
cnxCode: string;
exitStatusOnFailure: boolean | null;
exitStatusOnNoObtainedData: boolean | null;
exitStatusOnObtainedData: boolean | null;
orderField: string;
params: SqlParam[];
query: string;
}

